import Section from "../Section/Section";
import cleanaway from "../../Images/cleanaway.png";
import covantaEnergy from "../../Images/covanta-energy.svg";
import republicservices from "../../Images/republicservices.png";
import wastemgm from "../../Images/wastemgm.png";
import { Partner, PartnersGrid } from "./Partneri.elements";
import { useContext } from "react";
import { AosContext } from "../Context/AosContext";

const Partneri = () => {
  const images = [cleanaway, covantaEnergy, republicservices, wastemgm];

  return (
    <Section title="Nasi partneri" even>
      <PartnersGrid>
        {images.map((partner, i) => (
          <Partner key={i} data-aos="fade-up">
            <img src={partner} />
          </Partner>
        ))}
      </PartnersGrid>
    </Section>
  );
};

export default Partneri;
